import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

const LOGIN_URL = `${process.env.API_URL}auth/`
const RESET_URL = `${process.env.API_URL}auth/reset`

export default {
  user: {
    authenticated: false,
    data: {}
  },

  login (credentials) {
    return new Promise((resolve, reject) => {
      Vue.http.post(LOGIN_URL, credentials)
      .then((response) => {
        this.user.authenticated = true
        window.localStorage.setItem('id_token', response.body.token)
        resolve(response.body.token)
      }, (response) => {
        reject(response)
      })
    })
  },

  signup (creds) {
  },

  getAuthUser () {
    return new Promise((resolve, reject) => {
      if (this.user.data && this.user.data._id && this.user.data._id.length) return resolve(this.user.data)

      Vue.http.get(`${LOGIN_URL}`)
      .then(response => {
        this.user.data = response.body
        resolve(this.user.data)
      }, response => {
        this.logout().then(r => {
          reject(response)
        })
      })
    })
  },

  checkPermission (resource, desiredValue) {
    return new Promise((resolve, reject) => {
      this.getAuthUser()
      .then(userData => {
        const perm = userData.permissions.find(p => p.resource === resource)
        if (!perm) return reject({error: 'resource not found'})
        const check = (perm.value.includes(desiredValue))
        // let check = (checkAll) ? (permissions.every(p => perms.includes(p) || perms.includes('admin'))) : (permissions.some(p => perms.includes(p) || perms.includes('admin')))
        if (check) return resolve(check)
        return reject(check)
      })
    })
  },

  checkPermissionSync (resource, desiredValue) {
    let userData = this.user.data
    const perm = userData.permissions.find(p => p.resource === resource)
    if (!perm) return false
    return (perm.value.includes(desiredValue))
  },

  resetPassword (email) {
    return Vue.http.post(RESET_URL, {email: email})
  },

  findByToken (token) {
    return Vue.http.get(`${LOGIN_URL}passwordtoken/${token}`)
  },

  updatePassword (token, password) {
    return Vue.http.patch(`${LOGIN_URL}${token}/password`, {password: password})
  },

  logout () {
    return new Promise((resolve, reject) => {
      window.localStorage.removeItem('id_token')
      this.user.authenticated = false
      this.user.data = {}
      resolve(true)
    })
  },

  checkAuth () {
    const jwt = window.localStorage.getItem('id_token')
    if (jwt) {
      this.user.authenticated = true
      return true
    } else {
      this.user.authenticated = false
      this.user.data = {}
      return false
    }
  },

  setToken (token) {
    return new Promise((resolve, reject) => {
      this.user.authenticated = true
      window.localStorage.setItem('id_token', token)
      resolve(true)
    })
  },

  getToken () {
    return window.localStorage.getItem('id_token')
  },

  parseToken (token) {
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace('-', '+').replace('_', '/')
    return JSON.parse(window.atob(base64))
  },

  // checkPermission (permissions) {
  //   let token = this.getToken()
  //   if (!token) { return false }
  //   let payload = this.parseToken(token).data
  //   let perms = ['admin', ...permissions]
  //   return perms.some(v => payload.roles.includes(v))
  // },

  getAuthHeader () {
    return {
      'Authorization': 'Bearer ' + window.localStorage.getItem('id_token')
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.js